module.exports = __webpack_public_path__ + "img/spa.be8f5084.svg";